import { render, staticRenderFns } from "./ScanBerkasRM.vue?vue&type=template&id=12986d0f"
import script from "./ScanBerkasRM.vue?vue&type=script&lang=js"
export * from "./ScanBerkasRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12986d0f')) {
      api.createRecord('12986d0f', component.options)
    } else {
      api.reload('12986d0f', component.options)
    }
    module.hot.accept("./ScanBerkasRM.vue?vue&type=template&id=12986d0f", function () {
      api.rerender('12986d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/ScanBerkasRM.vue"
export default component.exports